document.addEventListener('userLoggedIn', function (event) {
    var dynamicPath = downloadReceipt.download_receipt_script_path;
    var script = document.createElement('script');
    script.src = dynamicPath;
    document.head.appendChild(script);
});
awUserLoggedInEvent();